import {
    SET_EMAIL_REQUEST_DATA,
    SET_DL_UPLOADED,
    SET_DL_SAVED,
    TEMPLATE_TYPE,    
    SET_SAVEREQUEST,
    SET_MASS_EMAIL_DATA,
    MODAL_TYPE,
    SET_SCHEDULE_MASS_EMAIL_DATA,
    SET_EMAIL_DLFILENAME,
    SET_EMAIL_SELECTEDDLFILE,
    SET_REQUESTID,
    SET_USE_TEMPLATE,
    SET_REQUEST_CANCELED,
    SET_ORIGIN,
    SET_TEMPLATE_CHANGE
} from './mmSendMassEmailReqDetailsAction';

const initialState = {
    mmSearchData: {
        searchObj: '',
        FieldName: '',
        SortBy: '',
        PageNo: '',
        RowCount: '',
        RowTitle: '',

    },
    useTemplate: 0,
    templateType: '',
    reqId: '',
    isDlUploaded: 0,
    isDlSaved: 0,
    mmSendEmailStatus: 0,
    mmSendEmailText: '',
    mmScheduleEmailStatus: 0,
    mmScheduleEmailText: '',
    modal_type: 0,
    emailDlFileName: "Choose Distribution List",
    emailSelectedFile: {},
    isRequestCanceled: 0,
    isComingFromLandingPage: 0,
    saveRequest: '',
    isTemplateChange: 0,
};
const mmSendMassEmailReqDetails = (state = initialState, action) => {
    switch (action.type) {
        case SET_TEMPLATE_CHANGE:
            return Object.assign({}, state, {
                isTemplateChange: action.value
            })
        case SET_ORIGIN:
            return Object.assign({}, state, {
                isComingFromLandingPage: action.value
            })
        case SET_SAVEREQUEST:
            return Object.assign({}, state, {
                saveRequest: action.value
            })
        case SET_REQUESTID:
            return Object.assign({}, state, {
                reqId: action.value
            })
        case SET_REQUEST_CANCELED:
            return Object.assign({}, state, {
                isRequestCanceled: action.value
            })
        case SET_USE_TEMPLATE:
            return Object.assign({}, state, {
                useTemplate: action.value
            })
        case SET_EMAIL_DLFILENAME:
            return Object.assign({}, state, {
                emailDlFileName: action.value
            })
        case SET_EMAIL_SELECTEDDLFILE:
            return Object.assign({}, state, {
                emailSelectedFile: action.value
            })

        case MODAL_TYPE:// 1 for cancel, 2 for send mass email 3 for schedule mass email
            return Object.assign({}, state, {
                modal_type: action.value
            })
        case TEMPLATE_TYPE:// 1 for cancel, 2 for send mass email 3 for schedule mass email
            return Object.assign({}, state, {
                templateType: action.value
            })

        case SET_EMAIL_REQUEST_DATA:
            return Object.assign({}, state, {
                mmSearchData: action.value
            })

        case SET_DL_UPLOADED:
            return Object.assign({}, state, {
                isDlUploaded: action.value
            })
        case SET_DL_SAVED:
            return Object.assign({}, state, {
                isDlSaved: action.value
            })
       

        case SET_MASS_EMAIL_DATA:
            return Object.assign({}, state, {
                mmSendEmailStatus: action.status,
                mmSendEmailText: action.text
            })
        case SET_SCHEDULE_MASS_EMAIL_DATA:
            return Object.assign({}, state, {
                mmScheduleEmailStatus: action.status,
                mmScheduleEmailText: action.text
            })
        default:
            return state;
    }
}
export default mmSendMassEmailReqDetails;